import MediaBoxComponent from '@wix/thunderbolt-elements/src/components/MediaContainers/MediaBox/viewer/MediaBox';


const MediaBox = {
  component: MediaBoxComponent
};


export const components = {
  ['MediaBox']: MediaBox
};

